import { useState } from 'react'
import { BaseScatola } from '@lucan/base-ui'
import FormLetturaDb from './FormLetturaDb'
import RisultatiLetturaDb from './RisultatiLetturaDb'

export default function LetturaDb() {
  const [ris, setRisultati] = useState(null)

  return (
    <>
      <BaseScatola>
        <FormLetturaDb setRisultati={setRisultati}></FormLetturaDb>
      </BaseScatola>
      {ris &&
        <BaseScatola>
          <RisultatiLetturaDb risultati={ris.data} />
        </BaseScatola>
      }
    </>
  )
}
